import { defaultNetwork } from '@/constants/walletConnectionConfig';

export const parseEthereumURI = (uri: string): string | null => {
  const match = uri.match(/^ethereum:([0-9a-fA-Fx]+)@/);
  return match ? match[1] : null;
};

export const getWalletErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    const code = (error as { code?: number }).code;
    switch (code) {
      case 4001:
        return 'Request rejected by user';
      case -32002:
        return 'Request already pending. Please check MetaMask';
      case -32603:
        return 'MetaMask encountered an error. Please try again';
      default:
        return error.message;
    }
  }
  return 'An unknown error occurred';
};

export const createEthereumURI = (address: string): string => {
  return `ethereum:${address}@${defaultNetwork.id}`;
};
